import { Base64 } from "js-base64";

export const combineStrings = (value) => {
  // Mengubah value menjadi uppercase
  value = value.toUpperCase();

  // Split key dan value menjadi array
  let keyArr = process.env.REACT_APP_KEY_STATUS_USER.split("");
  let valueArr = value.split("");

  // Menyisipkan huruf pertama value setelah angka '3'
  const index3 = keyArr.indexOf("3");
  if (index3 !== -1 && valueArr.length > 0) {
    keyArr.splice(index3 + 1, 0, valueArr.shift());
  }

  // Menyisipkan huruf kedua value setelah karakter '.'
  const indexDot = keyArr.indexOf(".");
  if (indexDot !== -1 && valueArr.length > 0) {
    keyArr.splice(indexDot + 1, 0, valueArr.shift());
  }

  // Menggabungkan sisa huruf value ke akhir key
  keyArr = keyArr.concat(valueArr);

  let res_encode = Base64.encode(keyArr.join(""));

  // Menggabungkan kembali array menjadi string
  return res_encode;
};

export const extractValueFromCombined = (combined) => {
//   console.log(combined);
  let res_decode = Base64.decode(combined);
  // Array untuk menampung hasil ekstraksi
  let extracted = [];

  // Temukan posisi huruf pertama setelah angka '3'
  const index3 = res_decode.indexOf("3");
  if (index3 !== -1 && res_decode[index3 + 1].match(/[A-Z]/)) {
    extracted.push(res_decode[index3 + 1]);
  }

  // Temukan posisi huruf kedua setelah karakter '.'
  const indexDot = res_decode.indexOf(".");
  if (indexDot !== -1 && res_decode[indexDot + 1].match(/[A-Z]/)) {
    extracted.push(res_decode[indexDot + 1]);
  }

  // Ekstrak sisa huruf besar setelah huruf 's' kecil terakhir
  const lastIndexS = res_decode.lastIndexOf("s");
  for (let i = lastIndexS + 1; i < res_decode.length; i++) {
    if (res_decode[i].match(/[A-Z]/)) {
      extracted.push(res_decode[i]);
    }
  }

  // Urutkan huruf yang diekstrak sesuai urutan penyisipan
  //   extracted.sort((a, b) => {
  //     const indexA = res_decode.indexOf(a);
  //     const indexB = res_decode.indexOf(b);
  //     return indexA - indexB;
  //   });

  // Menggabungkan kembali array menjadi string
  return extracted.join("");
};


export const extractFileName = (s3Url) => {
  // Gunakan URL API bawaan untuk parsing URL
  try {
    const url = new URL(s3Url);
    const path = url.pathname; // Mengambil bagian path dari URL
    return path.substring(path.lastIndexOf("/") + 1); // Mengambil nama file
  } catch (error) {
    console.error("Invalid URL:", error.message);
    return null;
  }
}
